import { FC } from 'react'
import { Navigate } from 'react-router-dom'

import { useInternalAdminAccessCheck } from '../../../features/account/hooks/roleHooks'

/**
 * Opens the Dashboard for users who can open it and Live Events Tracking, the one page every internal user can open, for others
 */
export const InternalHomeRedirect: FC = () => {
  const canOpenDashboard = useInternalAdminAccessCheck()

  return <Navigate replace to={canOpenDashboard ? '/internal/dashboard' : '/internal/live-events-tracking'} />
}
